import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Box } from 'roo-ui/components';
import { overflow } from 'styled-system';

// Despite the vendor prefixes, this CSS is supported by all major browsers for backwards
// compatibility. See: https://css-tricks.com/line-clampin/#article-header-id-0
// This component should only be used where progressive enhancement is acceptable as
// IE will never support this. `line-clamp` is in the spec, so we should be able to clean
// up the prefixes one day.

const Truncate = styled(Box)`
  ${overflow}
  -webkit-line-clamp: ${(props) => props.lines};
  -webkit-box-orient: vertical;
`;

Truncate.propTypes = {
  children: PropTypes.node,
  lines: PropTypes.number,
};

Truncate.defaultProps = {
  children: null,
  lines: 1,
  display: '-webkit-box',
  overflow: 'hidden',
};

export default Truncate;
